var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnswerCorrect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "answer_correct_svg__answer-correct",
    transform: "translate(17971 4754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "answer_correct_svg__Group_41487",
    "data-name": "Group 41487",
    transform: "translate(-1852 370)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "answer_correct_svg__check_circle_FILL1_wght400_GRAD0_opsz24",
    d: "M14,26a11.679,11.679,0,0,1-4.68-.946A11.974,11.974,0,0,1,2.946,18.68,11.679,11.679,0,0,1,2,14a11.679,11.679,0,0,1,.946-4.68A11.981,11.981,0,0,1,9.32,2.944,11.691,11.691,0,0,1,14,2a11.691,11.691,0,0,1,4.68.944A11.981,11.981,0,0,1,25.054,9.32,11.679,11.679,0,0,1,26,14a11.679,11.679,0,0,1-.946,4.68,11.974,11.974,0,0,1-6.374,6.374A11.679,11.679,0,0,1,14,26Z",
    transform: "translate(-16121 -5126)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "answer_correct_svg__Union_18",
    "data-name": "Union 18",
    d: "M0,5.768,1.768,4l3.25,3.25L12.268,0l1.768,1.768-8,8L6.018,9.75,5,10.768Z",
    transform: "translate(-16114 -5117)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswerCorrect);
export default __webpack_public_path__ + "static/media/answer_correct.f353b22781b0dde3b421ce9fcb9f24e8.svg";
export { ForwardRef as ReactComponent };